const ProfileModal = {
    element: null,

    show: function () {
        if (!window.AuthManager || !window.AuthManager.user) return;
        this.render();
    },

    hide: function () {
        if (this.element) this.element.remove();
        this.element = null;
    },

    render: function () {
        if (this.element) this.element.remove();

        const profile = window.AuthManager.profile || {};
        const username = profile.username || window.AuthManager.user.email.split('@')[0];
        const winCount = profile.correct_count || 0;
        const lossCount = profile.wrong_count || 0;
        const totalPoints = profile.total_points || 0;

        const modal = document.createElement('div');
        Object.assign(modal.style, {
            position: 'fixed', top: '0', left: '0', width: '100%', height: '100%',
            background: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(8px)',
            display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: '20000',
            fontFamily: "'Outfit', sans-serif"
        });

        const card = document.createElement('div');
        Object.assign(card.style, {
            background: '#1a1a1a',
            padding: window.innerWidth < 480 ? '20px 15px' : '30px',
            borderRadius: '24px',
            border: '1px solid rgba(255, 215, 0, 0.2)',
            width: 'min(440px, 92%)',
            boxShadow: '0 20px 50px rgba(0,0,0,0.8), 0 0 15px rgba(255, 215, 0, 0.1)',
            textAlign: 'center', position: 'relative',
            maxHeight: '90vh', overflowY: 'auto'
        });

        // Close Button
        const closeBtn = document.createElement('div');
        closeBtn.innerHTML = '✕';
        Object.assign(closeBtn.style, {
            position: 'absolute', top: '15px', right: '15px',
            color: '#aaa', cursor: 'pointer', fontSize: '1.2rem'
        });
        closeBtn.onclick = () => this.hide();
        card.appendChild(closeBtn);

        // Header
        const header = document.createElement('h2');
        header.innerText = "PROFİL AYARLARI";
        header.style.color = "var(--accent-gold)";
        header.style.marginBottom = "20px";
        header.style.fontSize = "1.5rem";
        card.appendChild(header);

        // User Info
        const userInfo = document.createElement('div');
        userInfo.style.marginBottom = "25px";
        userInfo.innerHTML = `
            <div style="font-size:1.2rem; font-weight:bold; color:#fff; margin-bottom:5px;">${username}</div>
            <div style="font-size:0.9rem; color:#888;">${window.AuthManager.user.email} (Gizli)</div>
        `;
        card.appendChild(userInfo);

        // Stats Variables
        const klasikWon = profile.klasik_won || 0;
        const klasikLost = profile.klasik_lost || 0;
        const carkWon = profile.cark_won || 0;
        const carkLost = profile.cark_lost || 0;
        const ruletWon = profile.rulet_won || 0;
        const ruletLost = profile.rulet_lost || 0;

        // Stats Grid
        const statsGrid = document.createElement('div');
        Object.assign(statsGrid.style, {
            display: 'flex', flexDirection: 'column', gap: '15px',
            marginBottom: '30px', padding: '15px', background: 'rgba(255,255,255,0.05)',
            borderRadius: '10px'
        });

        // Toplam Puan Section
        statsGrid.innerHTML = `
            <div style="text-align:center; padding-bottom: 15px; border-bottom: 1px solid rgba(255,255,255,0.1);">
                <div style="font-size: ${window.innerWidth < 480 ? '1.8rem' : '2.2rem'}; color:var(--accent-gold); font-weight:bold; text-shadow: 0 0 10px rgba(255,215,0,0.5);">${totalPoints}</div>
                <div style="font-size:0.75rem; color:#aaa; font-weight:800; letter-spacing: 2px;">TOPLAM PUAN</div>
            </div>
            
            <div style="display:grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-top: 10px;">
                <div style="background: rgba(0,0,0,0.3); padding: 12px 8px; border-radius: 12px; border: 1px solid rgba(255,255,255,0.1);">
                    <div style="font-size:0.7rem; color:#888; font-weight:bold; margin-bottom: 5px; text-transform: uppercase;">KLASİK BİLGİ</div>
                    <div style="display:flex; justify-content:center; gap: 15px; font-size: 1.1rem;">
                        <span style="color:#2ecc71; font-weight:800;">${klasikWon} <small style="font-size:0.7rem;">✓</small></span>
                        <span style="color:#e74c3c; font-weight:800;">${klasikLost} <small style="font-size:0.7rem;">✗</small></span>
                    </div>
                </div>
                
                <div style="background: rgba(0,0,0,0.3); padding: 12px 8px; border-radius: 12px; border: 1px solid rgba(255,255,255,0.1);">
                    <div style="font-size:0.7rem; color:#888; font-weight:bold; margin-bottom: 5px; text-transform: uppercase;">ŞANS ÇARKI</div>
                    <div style="display:flex; justify-content:center; gap: 15px; font-size: 1.1rem;">
                        <span style="color:#2ecc71; font-weight:800;">${carkWon} <small style="font-size:0.7rem;">✓</small></span>
                        <span style="color:#e74c3c; font-weight:800;">${carkLost} <small style="font-size:0.7rem;">✗</small></span>
                    </div>
                </div>
            </div>

            <div style="background: rgba(0,0,0,0.3); padding: 12px 8px; border-radius: 12px; border: 1px solid rgba(255,255,255,0.1); margin-top: 5px;">
                <div style="font-size:0.7rem; color:#888; font-weight:bold; margin-bottom: 5px; text-transform: uppercase;">GADDAR RULET</div>
                <div style="display:flex; justify-content:center; gap: 25px; font-size: 1.1rem;">
                     <span style="color:#2ecc71; font-weight:800;">${ruletWon} <small style="font-size:0.7rem;">✓</small></span>
                     <span style="color:#e74c3c; font-weight:800;">${ruletLost} <small style="font-size:0.7rem;">✗</small></span>
                </div>
            </div>
        `;
        card.appendChild(statsGrid);

        // Buttons
        const logoutBtn = document.createElement('button');
        logoutBtn.innerText = "KAYDET & ÇIKIŞ YAP";
        Object.assign(logoutBtn.style, {
            width: '100%', padding: '12px', borderRadius: '10px',
            border: 'none', background: '#c0392b', color: '#fff',
            fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer',
            marginTop: '10px', transition: '0.2s'
        });
        logoutBtn.onclick = () => {
            if (confirm("Çıkış yapmak istediğinize emin misiniz?")) {
                window.AuthManager.logout();
            }
        };
        card.appendChild(logoutBtn);

        modal.appendChild(card);
        document.body.appendChild(modal);
        this.element = modal;

        modal.onclick = (e) => {
            if (e.target === modal) this.hide();
        };
    }
};

window.ProfileModal = ProfileModal;
